module.exports = __webpack_public_path__ + "img/img-9bfea4.png";